import { FC, useEffect } from 'react';

import { Col, Input, Row, Typography } from 'antd';
import { ErrorMessage, Formik, useFormikContext } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';

import * as S from './styled';

export type VirtualGroupEditFormProps = {
  initialValues: any;
  loading: boolean;
  onSubmit: any;
};

export enum VoucherExpireType {
  ExpirationDate = 'EXPIRATION_DATE',
  UsesPerUser = 'USES_PER_USER',
}

const UpdateChargeboxes = () => {
  const { setFieldValue, setValues } = useFormikContext();
  const { state } = useLocation<any>();

  useEffect(() => {
    if (state?.payload) {
      setValues(state.payload);

      setFieldValue('charge_boxs', state?.payload?.charge_boxs);
    }
  }, [setValues, setFieldValue, state]);

  return null;
};

const VirtualGroupEditForm: FC<VirtualGroupEditFormProps> = ({ initialValues, loading, onSubmit }) => {
  const history = useHistory();

  return (
    <Formik
      validateOnMount
      initialValues={initialValues}
      validate={(values) => {
        const errors: any = {};
        let hasError = false;

        if (!values.name) {
          hasError = true;
          errors.name = 'O nome do grupo é um campo obrigatório';
        }

        if (!values.description) {
          hasError = true;
          errors.description = 'A descrição é um campo obrigatório';
        }

        return hasError ? errors : {};
      }}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, handleChange, values }) => {
        return (
          <>
            <form onSubmit={handleSubmit}>
              <Row gutter={24}>
                <Col md={24}>
                  <Typography.Title level={5}>Informações</Typography.Title>
                </Col>
              </Row>
              <Row gutter={24} style={{ marginTop: 8 }}>
                <Col md={12}>
                  <S.Label>Nome da configuração</S.Label>
                  <Input
                    name='name'
                    size='large'
                    disabled={loading}
                    onChange={handleChange}
                    maxLength={30}
                    value={values.name}
                  />
                  <ErrorMessage name='name' component={S.MessageBox} />
                </Col>

                <Col md={12}>
                  <S.Label>Descrição</S.Label>
                  <Input
                    name='description'
                    size='large'
                    disabled={loading}
                    onChange={handleChange}
                    maxLength={50}
                    value={values.description}
                  />
                  <ErrorMessage name='description' component={S.MessageBox} />
                </Col>
              </Row>

              <Row style={{ marginTop: 32, justifyContent: 'space-between' }}>
                <S.Button disabled={loading} size='large' danger onClick={history.goBack}>
                  Cancelar
                </S.Button>

                <S.Button loading={loading} key='submit' size='large' type='primary' htmlType='submit'>
                  Salvar alterações
                </S.Button>
              </Row>
            </form>
            <UpdateChargeboxes />
          </>
        );
      }}
    </Formik>
  );
};

export default VirtualGroupEditForm;
